import React, { useState } from 'react';
import api from '../../../services/api';
import TopicOverlay from './TopicOverlay'; 
import '../../../css/topicList.css';

const TopicList = ({ topics, refreshTopicsList }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleCount, setVisibleCount] = useState(20);
  const [success, setSuccess] = useState('');
  const [editingTopic, setEditingTopic] = useState(null);

  const filteredTopics = topics.filter(topic =>
    topic.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleVisible = () => {
    if (visibleCount === filteredTopics.length) {
      setVisibleCount(20);
    } else {
      setVisibleCount(filteredTopics.length);
    }
  };

  const handleEdit = (id) => {
    const topic = topics.find(t => t.id === id);
    if (topic) {
      setEditingTopic(topic);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo topic?")) return;
    try {
      await api.delete(`/topics/${id}`);
      setSuccess("Topic eliminato con successo!");
      setTimeout(() => setSuccess(""), 2000);
      if (refreshTopicsList) refreshTopicsList();
    } catch (error) {
      console.error("Errore nell'eliminazione del topic:", error);
    }
  };

  const closeOverlay = () => {
    setEditingTopic(null);
  };

  return (
    <div className="topic-list">
      <div className="topic-list-search">
        <input
          type="text"
          placeholder="Cerca Topic..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="topic-search"
        />
      </div>

      <div className="topic-list-items">
        {success && <p className="success">{success}</p>}
        {filteredTopics.slice(0, visibleCount).map(topic => (
          <div key={topic.id} className="topic-card">
            <h3>{topic.name}</h3>
            <p>{topic.description}</p>
            <div className="topic-actions">
              <button onClick={() => handleEdit(topic.id)}>Modifica</button>
              <button onClick={() => handleDelete(topic.id)}>Elimina</button>
            </div>
          </div>
        ))}
      </div>

      {filteredTopics.length > 20 && (
        <button onClick={toggleVisible} className="redirect-btn">
          {visibleCount === filteredTopics.length ? 'Mostra meno' : 'Mostra altro'}
        </button>
      )}

      {editingTopic && (
        <TopicOverlay
          topic={editingTopic}
          onClose={closeOverlay}
          onUpdate={refreshTopicsList}
        />
      )}
    </div>
  );
};

export default TopicList;
